var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17160",
    "data-name": "Group 17160",
    transform: "translate(-380 -282)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(380 282)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cake",
    transform: "translate(383 284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17158",
    "data-name": "Group 17158",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17157",
    "data-name": "Group 17157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M193.438,4.636A1.546,1.546,0,0,0,194.764,2.3L193.438,0l-1.325,2.3a1.546,1.546,0,0,0,1.325,2.341Z",
    transform: "translate(-186.484)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8339",
    "data-name": "Path 8339",
    d: "M54.151,150.879H50.287v-1.545H48.742v1.545H44.878A2.32,2.32,0,0,0,42.56,153.2v1.19a1.514,1.514,0,0,0,2.585,1.07l1.654-1.65,1.65,1.646a1.55,1.55,0,0,0,2.14,0l1.654-1.646,1.65,1.646a1.514,1.514,0,0,0,2.585-1.07V153.2A2.332,2.332,0,0,0,54.151,150.879Z",
    transform: "translate(-42.56 -143.924)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8340",
    "data-name": "Path 8340",
    d: "M53.065,318.911h0l-.831-.831-.835.831a2.738,2.738,0,0,1-3.779,0l-.831-.831-.835.831a2.62,2.62,0,0,1-1.882.784,2.668,2.668,0,0,1-1.515-.475v3.566a.775.775,0,0,0,.773.773H55.7a.775.775,0,0,0,.773-.773V319.22a2.661,2.661,0,0,1-3.4-.309Z",
    transform: "translate(-42.56 -306.559)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.6b41d63ecdc53b6e049e3c7d31467cc4.svg";
export { ForwardRef as ReactComponent };